/* eslint-disable curly */
/* eslint-disable no-param-reassign */
/* eslint-disable import/no-named-as-default */
/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
/* eslint-disable import/extensions */
/* eslint-disable no-use-before-define */
import React, { useEffect, useState } from 'react';
import makeApi, { URLS } from 'Utils/apiUtil';
import BulkPopupMessage from './BulkUploadingMesage';
import AddToSeqLoader from './AddToSeqLoader';
import { purchaseStatusPopupState } from '../../common/purchaseStatusPopup';

const BulkContactValidationPopup = props => {
  const { closePopup, selectedSeqId, bulkContactAddToSeq, contactIds } = props;

  const [errorDetails, setErrorDetails] = useState(false);
  const [showSkipContactsBtn, setShowSkipContactsBtn] = useState(false);
  const [showBulkUploadingLoader, setShowBulkUploadingLoader] = useState(true);
  const [showMessage, setShowMessage] = useState(false);

  const validateMandatoryFields = async validationPayload => {
    // By default tracking enabled
    if (validationPayload) {
      validationPayload.sequenceId = selectedSeqId;
      const payload = validationPayload;
      const config = {
        url: URLS.salesgear.validateMandatoryFields,
        method: 'POST',
        data: payload,
      };

      const response = await makeApi(config);
      if (response && response.data) {
        const {
          validCount,
          uploadedCount,
          missingFields,
          validContactIds,
        } = response.data;
        if (
          validCount === uploadedCount &&
          validContactIds &&
          validContactIds.length
        ) {
          bulkContactAddToSeq(validContactIds);
        } else
          handleBulkUploadContactError(
            validCount,
            uploadedCount,
            missingFields,
            validContactIds,
          );
      } else {
        closePopup();
        purchaseStatusPopupState.setToastMsg(
          null,
          null,
          null,
          null,
          null,
          'Something went wrong. Plese try again later',
        );
      }
    }
  };

  const handleBulkUploadContactError = (
    validCount,
    uploadedCount,
    missingFields,
    validContactIds,
  ) => {
    setShowBulkUploadingLoader(false);
    setShowMessage(true);
    if (validCount === 0) {
      setShowSkipContactsBtn(false);
    } else setShowSkipContactsBtn(true);

    setErrorDetails(
      constructErrorDetails(
        validCount,
        uploadedCount,
        missingFields,
        validContactIds,
      ),
    );
  };

  const skipAndUploadContact = validContactIds => {
    bulkContactAddToSeq(validContactIds);
  };

  const constructErrorDetails = (
    validCount,
    uploadedCount,
    missingFields,
    validContactIds,
  ) => {
    const tempObj = {
      validCount,
      uploadedCount,
      missingFields,
      validContactIds,
      cbk: skipAndUploadContact,
      closePopup,
    };
    return tempObj;
  };

  useEffect(() => {
    validateMandatoryFields(contactIds);
  }, [contactIds]);

  return (
    <>
      <div className="overlayMask" />
      <div className="validateMandatoryFieldsWrapper">
        <div className="bulkPopupValidationCont">
          {showBulkUploadingLoader && (
            <AddToSeqLoader
              loadingMessage={'We are processing your contacts. Please wait...'}
            />
          )}
          {showMessage && !showBulkUploadingLoader && (
            <BulkPopupMessage
              errorDetails={errorDetails}
              showSkipContacts={showSkipContactsBtn}
              closePopup={closePopup}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default BulkContactValidationPopup;
export { BulkContactValidationPopup };
